import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import { useFeature } from "../../../hooks/useFeature";
import useStore from "../../../context/useStore";

const Panel = dynamic(() => import("./Panel"), {
  suspense: true,
});

interface BasicProps {
  data: any;
}

const Basic: React.FC<BasicProps> = ({ data }) => {
  const { onFeature } = useFeature(data);

  const { auth, properties } = useStore();

  return (
    <Suspense fallback={<></>}>
      <Panel
        Header={
          <div className="flex gap-2 justify-between items-center">
            <div className="font-semibold text-lg ">
              <span
                className={`text-primary text-justify ${
                  data.Lock && !auth.verify ? "blur-sm select-none" : ""
                }`}
              >
                $ {data.ListPrice.toLocaleString()}
              </span>
            </div>
            <div className="text-red-600 text-2xl cursor-pointer">
              {(auth.login === true && (
                <>
                  {(properties.includes(data.ListingKey) && (
                    <AiFillHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onFeature();
                      }}
                    />
                  )) || (
                    <AiOutlineHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onFeature();
                      }}
                    />
                  )}
                </>
              )) || (
                <AiOutlineHeart
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onFeature();
                  }}
                />
              )}
            </div>
          </div>
        }
      >
        <div className="flex gap-2 justify-between items-center flex-wrap">
          <div className="flex flex-col gap-2">
            <h1
              className={`text-lg font-medium text-justify ${
                data.Lock && !auth.verify ? "blur-sm select-none" : ""
              }`}
            >
              {data.UnparsedAddress}
            </h1>
            <h4
              className={`text-base text-justify ${
                data.Lock && !auth.verify ? "blur-sm select-none" : ""
              }`}
            >
              {data.City}, ON, {data.PostalCode}
            </h4>
          </div>
          <div className="flex flex-col items-end gap-2">
            <p className="text-gray-500">
              MLS® Number :{" "}
              <span
                className={`text-sm text-justify ${
                  data.Lock && !auth.verify ? "blur-sm select-none" : ""
                }`}
              >
                {" "}
                {data.ListingKey}
              </span>
            </p>
            <p
              className={`text-sm text-justify ${
                data.Lock && !auth.verify ? "blur-sm select-none" : ""
              }`}
            >
              {data.BedroomsTotal || "--"} Beds / {data.BathroomsTotalInteger} Baths / {data.ParkingTotal} Parking
            </p>
          </div>
        </div>
        <div className="flex justify-end">
          <p
            className={`text-sm text-justify text-gray-500 ${
              data.Lock && !auth.verify ? "blur-sm select-none" : ""
            }`}
          >
            {`Lot Front: ${data.LotWidth} Feet / Lot Depth: ${
              data.LotDepth || "--"
            } Feet `}
          </p>
        </div>
      </Panel>
    </Suspense>
  );
};

export default Basic;
